import { createSelector } from 'reselect'
import { memoize } from '@exodus/basic-utils'
import { MY_STATE } from '@exodus/redux-dependency-injection'

function selectorFactory(selfSelector) {
  return memoize((experimentId) =>
    createSelector(selfSelector, ({ loading, experiments }) =>
      loading ? false : experiments[experimentId]?.enabled
    )
  )
}

const createExperimentEnabledSelectorDefinition = {
  id: 'createExperimentEnabled',
  selectorFactory,
  dependencies: [{ selector: MY_STATE }],
}

export default createExperimentEnabledSelectorDefinition
